// src/components/layout/SharedHeader.js
import React from 'react';
import UserMenu from '../common/UserMenu';

const SharedHeader = ({ 
  user, 
  userProfile, 
  userRole,
  selectedCompany,
  companies,
  setSelectedCompany,
  setActiveTab,
  onShowSubscriptions,
  onAskQuestion
}) => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-end items-center py-4">
            {/* Right side - Company selector and User menu */}
            <div className="flex items-center space-x-4">
              {/* Company Selector (only for products with companies) */}
              {companies && companies.length > 0 && setSelectedCompany && (
                <div className="hidden sm:block">
                  <select
                    value={selectedCompany?.id || ''}
                    onChange={(e) => {
                      const company = companies.find(c => c.id === parseInt(e.target.value));
                      setSelectedCompany(company);
                      if (setActiveTab) setActiveTab('overview');
                    }}
                    className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Select Company</option>
                    {companies.map(company => (
                      <option key={company.id} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* User Menu */}
              {user && (
                <UserMenu 
                  user={user}
                  userProfile={userProfile}
                  userRole={userRole}
                />
              )}
            </div>
          </div>
        </div>
      </header>
  );
};

export default SharedHeader;
